import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

export const submitEnquiry = (payload) => axios.post(`${API}/enquiries`, payload);

const TOKEN_KEY = "paradisio_owner_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeader = () => ({
  headers: getToken() ? { Authorization: `Bearer ${getToken()}` } : {},
  withCredentials: true,
});

export const login = (email, password) => axios.post(`${API}/auth/login`, { email, password });
export const fetchMe = () => axios.get(`${API}/auth/me`, authHeader());

// Emergent Google sign-in: exchange the one-time session_id for an httpOnly session cookie
export const exchangeGoogleSession = (sessionId) =>
  axios.post(`${API}/auth/session`, null, {
    headers: { "X-Session-ID": sessionId },
    withCredentials: true,
  });
export const logoutSession = () => axios.post(`${API}/auth/logout`, null, { withCredentials: true });
export const getEnquiries = () => axios.get(`${API}/enquiries`, authHeader());
export const setEnquiryRead = (id, isRead) =>
  axios.patch(`${API}/enquiries/${id}`, null, { params: { is_read: isRead }, ...authHeader() });
export const setEnquiryReplied = (id, replied) =>
  axios.patch(`${API}/enquiries/${id}`, null, { params: { replied }, ...authHeader() });
export const deleteEnquiry = (id) => axios.delete(`${API}/enquiries/${id}`, authHeader());

export const getBlockedDates = (slug) =>
  axios.get(`${API}/blocked-dates`, { params: slug ? { property_slug: slug } : {} });
export const addBlockedDate = (payload) => axios.post(`${API}/blocked-dates`, payload, authHeader());
export const deleteBlockedDate = (id) => axios.delete(`${API}/blocked-dates/${id}`, authHeader());
export const getPhotos = (slug) =>
  axios.get(`${API}/photos`, { params: slug ? { property_slug: slug } : {} });
export const getLibraryManaged = (slug) => axios.get(`${API}/photos/library-managed/${slug}`);
export const uploadPhoto = (slug, file) => {
  const form = new FormData();
  form.append("property_slug", slug);
  form.append("file", file);
  return axios.post(`${API}/photos`, form, authHeader());
};
export const deletePhoto = (id) => axios.delete(`${API}/photos/${id}`, authHeader());
export const getAllPhotos = () => axios.get(`${API}/photos/all`, authHeader());
export const reassignPhoto = (id, slug) =>
  axios.patch(`${API}/photos/${id}`, null, { params: { property_slug: slug }, ...authHeader() });
export const setPhotoCaption = (id, caption) =>
  axios.patch(`${API}/photos/${id}`, null, { params: { caption }, ...authHeader() });
export const importPhotos = (slug, urls) =>
  axios.post(`${API}/photos/import`, { property_slug: slug, urls }, authHeader());
export const photoSrc = (p) => (p.external_url ? p.external_url : fileUrl(p.storage_path));

export const getPropertyContent = () => axios.get(`${API}/property-content`);
export const savePropertyContent = (slug, payload) =>
  axios.put(`${API}/property-content/${slug}`, payload, authHeader());

export const getReviews = (slug) =>
  axios.get(`${API}/reviews`, { params: slug ? { property_slug: slug } : {} });
export const getAllReviews = () => axios.get(`${API}/reviews/all`, authHeader());
export const setReviewPublished = (id, isPublished) =>
  axios.patch(`${API}/reviews/${id}`, null, { params: { is_published: isPublished }, ...authHeader() });
export const setReviewRead = (id, isRead) =>
  axios.patch(`${API}/reviews/${id}`, null, { params: { is_read: isRead }, ...authHeader() });
export const deleteReview = (id) => axios.delete(`${API}/reviews/${id}`, authHeader());
export const requestReview = (payload) => axios.post(`${API}/review-requests`, payload, authHeader());
export const getReviewRequest = (token) => axios.get(`${API}/review-requests/${token}`);
export const submitReview = (token, payload) => axios.post(`${API}/review-requests/${token}`, payload);
export const uploadReviewPhoto = (token, file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API}/review-requests/${token}/photos`, form);
};
export const deleteReviewPhoto = (id, path) =>
  axios.delete(`${API}/reviews/${id}/photos`, { params: { path }, ...authHeader() });
export const reviewPhotoToGallery = (id, path) =>
  axios.post(`${API}/reviews/${id}/photos/to-gallery`, null, { params: { path }, ...authHeader() });
